<template>
    <div class="loginpage">
        <img class="top_right_img" src="../../assets/icon/pangao_pic3.png" alt="" />
        <img class="bottom_left_img" src="../../assets/icon/pangao_pic2.png" alt="" />
        <div class="mainBox">
            <div class="loginbox">
                <div class="input-user">
                    <div><img src="../../assets/icon/pangao_login_user_ic.png" /></div>
                    <input placeholder="请输入用户名" v-model="username" type="text" />
                </div>
                <div class="input-user">
                    <div><img src="../../assets/icon/pangao_login_password_ic.png" /></div>
                    <input placeholder="请输入密码" v-model="password" type="password" />
                </div>
                <div class="input-code">
                    <input v-model="vcode" @keyup.enter="login" maxlength="4" placeholder="验证码" />
                    <img :src="codeImgUrl" alt="验证码" @click="getVCode()" />
                </div>
                <div class="remember">
                    <label> <input type="checkbox" v-model="remember" /> 记住密码 </label>
                </div>
                <div class="login-btn-box">
                    <div class="login-btn" @click="login">登录</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { loginPro } from "../../http/login";
import { baseURL } from "../../http/http";
export default {
    data() {
        return {
            username: "",
            password: "",
            vcode: "",
            codeImgUrl: "",
            remember: false,
            requestUUID: "",
        };
    },
    methods: {
        onKeyDown(e) {
            if (e.keyCode == 13) {
                //回车键按下登录
                this.login();
            }
        },
        getVCode() {
            this.vcode = "";
            this.requestUUID = parseInt(Math.random() * 900000 + 100000);
            // this.codeImgUrl = baseURL + "/kaptcha/getKaptcha";
            this.codeImgUrl = baseURL + "/kaptcha/getKaptcha?random=" + this.requestUUID;
            //获取图片二进制流，转成base64
            // getVcode({
            //     requestUUID: this.requestUUID,
            // })
            //     .then((res) => {
            //         return "data:image/png;base64," + btoa(new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte), ""));
            //     })
            //     .then((data) => {
            //         this.codeImgUrl = data; //赋值给img标签的src属性
            //     });
        },
        login() {
            if (this.username === "" || this.username === undefined) {
                layer.msg("账户不能为空");
            } else if (this.password === "" || this.password === undefined) {
                layer.msg("密码不能为空");
            } else if (this.vcode === "" || this.vcode === undefined || this.vcode.length != 4) {
                layer.msg("请正确输入4位验证码");
            } else {
                // let md5pwd = this.$md5(this.password);
                // if (this.password.length == 32) {
                //     md5pwd = this.password;
                // }
                let userSaveInfo;
                try {
                    userSaveInfo = JSON.parse(localStorage.getItem("userInfo"));
                } catch (e) {
                    console.log(e);
                }
                // if (userSaveInfo) {
                //     if (userSaveInfo.password == this.password) {
                //         md5pwd = this.password;
                //     }
                // }
                let userInfo = {
                    username: this.username,
                    password: "",
                    remember: this.remember,
                };
                if (this.remember) {
                    // userInfo.password = md5pwd;
                    userInfo.password = this.password;
                } else {
                    userInfo.password = "";
                }
                localStorage.setItem("userInfo", JSON.stringify(userInfo)); //记住密码
                loginPro({
                    username: this.username,
                    // password: md5pwd,
                    password: this.password,
                    // verificationCode: this.vcode.toLowerCase(),
                    // verificationCode: this.vcode.toUpperCase(),
                    verificationCode: this.vcode,
                    random: this.requestUUID,
                }).then((res) => {
                    let toRoute = sessionStorage.getItem("currentTab") || "userList";
                    if (res.data.errCode == 0) {
                        sessionStorage.setItem("showname", res.data.result.username);
                        sessionStorage.setItem("token", res.data.result.token);
                        let sessionData = { ...res.data.result };
                        delete sessionData.token;
                        sessionStorage.setItem("userData", JSON.stringify(sessionData));
                        this.$router.push({ name: toRoute });
                    } else if (res.data.errCode == 11) {
                        this.getVCode();
                        layer.msg("验证码错误");
                    } else if (res.data.errCode == 31) {
                        this.getVCode();
                        layer.msg("用户名或密码错误");
                    } else {
                        this.getVCode();
                        layer.msg(res.data.errMsg);
                    }
                });
            }
        },
    },
    watch: {
        vcode(val) {
            this.vcode = val.replace(/\W/g, "");
        },
        username(val) {
            this.username = val.replace(/\s/g, "");
        },
    },
    mounted() {
        this.getVCode();
        try {
            let userInfo = JSON.parse(localStorage.getItem("userInfo"));
            if (userInfo) {
                this.username = userInfo.username;
                this.password = userInfo.password;
                this.remember = userInfo.remember;
            }
        } catch (e) {
            console.log(e);
        }
    },
    destroyed() {},
};
</script>

<style lang="scss" scoped>
.loginpage {
    background: #2b333e;
    height: 100vh;
    width: 100vw;
    min-width: 1200px;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
}
.top_right_img {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(45%, -45%);
    width: 40vw;
    z-index: 1;
    user-select: none;
}
.bottom_left_img {
    position: absolute;
    bottom: 0;
    left: 0;
    transform: translate(-60%, 45%);
    width: 52vw;
    z-index: 1;
    user-select: none;
}
.mainBox {
    width: 1190px;
    height: 568px;
    z-index: 2;
    background-image: url("../../assets/icon/pangao_login_bg1.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    &::after {
        content: "Copyright 2020 ElinkThings";
        display: block;
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        width: 1190px;
        height: 189px;
        background-image: url("../../assets/icon/pangao_login_bg2.png");
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        color: #fff;
        text-align: center;
        padding-top: 50px;
        box-sizing: border-box;
    }
}
.loginbox {
    position: absolute;
    right: 9%;
    top: 25%;
    z-index: 100;
    width: 400px;
    height: 425px;
    .inputIcon {
        width: 28px;
        height: 28px;
    }
    .input-user {
        padding: 0 30px 20px 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 65px;
        div {
            width: 50px;
            height: 45px;
            background-color: #e2e2e4;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
                width: 25px;
                height: 25px;
            }
        }
        input {
            height: 45px;
            line-height: 45px;
            flex: 1;
            border: none;
            padding: 0 20px;
            font-size: 16px;
            border: 1px solid #e2e2e4;
            outline-color: #0082fe;
        }
    }
    .input-code {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 30px 10px 30px;
        width: 100%;
        box-sizing: border-box;
        input {
            flex: 1;
            width: 100px;
            border: none;
            padding: 0 20px;
            height: 45px;
            line-height: 45px;
            font-size: 18px;
            border: 1px solid #ccc;
            outline-color: #0082fe;
        }
        img {
            width: 130px;
            height: 45px;
            flex-shrink: 1;
        }
    }
    .remember {
        color: #8c8c8c;
        padding: 0 30px 20px 30px;
        font-size: 16px;
        line-height: 36px;
        user-select: none;
        input {
            width: 18px;
            height: 18px;
            vertical-align: middle;
        }
    }
    .login-btn-box {
        padding: 0 30px;
        .login-btn {
            width: 100%;
            height: 45px;
            box-sizing: border-box;
            background: #ff8914;
            color: #fff;
            font-size: 20px;
            letter-spacing: 50px;
            text-indent: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            user-select: none;
            box-shadow: 0 0 10px 2px rgba($color: #ff8914, $alpha: 0.3);
            &:hover {
                background: rgba($color: #ff8914, $alpha: 0.8);
            }
            &:active {
                background: #ff7f00;
            }
        }
    }
}
</style>
